import { StorageService } from '../services/StorageService'
class AlgoliaService {

    async getEventAlgolia(eventName, eventSubtype) {
            let objectSessionAlgolia = StorageService.get("_key_argo_object") ? JSON.parse(StorageService.get("_key_argo_object")) : {};
            if (objectSessionAlgolia) {
                if (objectSessionAlgolia.queryID && objectSessionAlgolia.objectIDs) {
                    window.aa('clickedObjectIDsAfterSearch', {
                        userToken: objectSessionAlgolia.userToken,
                        index: objectSessionAlgolia.indexName ,
                        eventType: "conversion",
                        eventName: eventName,
                        queryID: objectSessionAlgolia.queryID,
                        objectIDs: [objectSessionAlgolia.objectIDs],
                        eventSubtype: eventSubtype && eventSubtype.length ? eventSubtype : ""
                    });
                }
            }
            let objectSessionAlgoliaNew = StorageService.get("_key_argo_object_n") ? JSON.parse(StorageService.get("_key_argo_object_n")) : {};
            if (objectSessionAlgoliaNew) {
                if (objectSessionAlgoliaNew.queryID && objectSessionAlgoliaNew.objectIDs) {
                    window.aa('clickedObjectIDsAfterSearch', {
                        index: objectSessionAlgoliaNew.index,
                        eventType: "conversion",
                        eventName: eventName,
                        objectIDs: objectSessionAlgoliaNew.objectIDs,
                        queryID: objectSessionAlgoliaNew.queryID,
                        userToken: objectSessionAlgoliaNew.userToken,
                        eventSubtype: eventSubtype && eventSubtype.length ? eventSubtype : ""
                    });
                }
            }   
    }
}

export const AlgoliaServices = new AlgoliaService();